import Vue from 'vue';

// Единый переключатель проверок прав на Front. Авторизацию и проверки бэка не отключает.
export const permSettings = Vue.observable({enabled: false});

export function userPerm(type, mode = 'read') {
  const scopes = {client: 'user.client', spec: 'user.spec.profile', admin: 'user.admin.profile', referral: 'user.referral'};
  return scopes[type] && ['read', 'manage'].includes(mode) ? scopes[type] + ':' + mode : false;
}

export function hasPerm(user, requirement) {
  if (!user) return false;
  if (!permSettings.enabled || requirement === undefined) return true;
  if (typeof requirement === 'string') return Array.isArray(user.perms) && user.perms.includes(requirement);
  if (Array.isArray(requirement)) return requirement.length > 0 && requirement.some(code => hasPerm(user, code));
  return false;
}

export function filterPermTabs(user, tabs) {
  return (tabs || []).filter(tab => hasPerm(user, tab.perm));
}
